export default __webpack_public_path__ + "assets/06efb5f8a208bd9608ee9b2f7877ffc0.png";